"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.9168 40.125H22.7918C22.1097 40.1193 21.4493 39.8845 20.9168 39.4583L5.85427 27.5C5.70006 27.3773 5.56028 27.2375 5.4376 27.0833C5.16786 26.764 4.96403 26.3944 4.83786 25.9958C4.71169 25.5973 4.66568 25.1777 4.70248 24.7613C4.73928 24.3449 4.85816 23.9399 5.05227 23.5696C5.24638 23.1994 5.51187 22.8713 5.83343 22.6042L20.8334 10.5625C21.2961 10.188 21.8555 9.95248 22.4467 9.88324C23.0378 9.81399 23.6365 9.91388 24.1732 10.1713C24.7098 10.4287 25.1625 10.8331 25.4785 11.3375C25.7945 11.8419 25.9609 12.4256 25.9584 13.0208V17.5833C35.1668 18.625 41.6251 23.8333 45.1876 32.875C45.1765 32.9088 45.1765 32.9453 45.1876 32.9792C45.3726 33.6159 45.3557 34.2943 45.1393 34.9211C44.9229 35.5478 44.5177 36.0921 43.9793 36.4792C43.4376 36.8737 42.7848 37.0863 42.1147 37.0863C41.4446 37.0863 40.7917 36.8737 40.2501 36.4792C35.4376 32.5833 30.8751 31.1458 25.9168 32V37.0208C25.9146 37.6165 25.7456 38.1996 25.429 38.704C25.1123 39.2085 24.6606 39.6142 24.1251 39.875C23.7431 40.0384 23.3322 40.1234 22.9168 40.125ZM22.9168 13.0417L7.8126 25L22.7501 36.9792V30.7292C22.7528 30.3802 22.8707 30.042 23.0854 29.767C23.3002 29.4919 23.5997 29.2956 23.9376 29.2083C30.3126 27.6667 36.2501 29.2083 42.1459 34.0208C40.9015 30.2056 38.5078 26.8685 35.2929 24.4666C32.078 22.0648 28.1991 20.7157 24.1876 20.6042C23.7915 20.5777 23.4203 20.4015 23.1495 20.1113C22.8786 19.8211 22.7284 19.4386 22.7293 19.0417L22.9168 13.0417Z",
    fill: fill
  }));
};

exports["default"] = _default;